import React, {useEffect} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {getCurrentLayout} from "../appLayout";
import {setStaticCanvasImage} from "../../actions/visualizerFunctions";
import {getRoomImageFromQtCategory} from "../../misc/categorySwitchingFunctions";
import {getCommonVisualizerType} from "../../config";

const HardcodedCanvasImage = (props) => {

  const {disableLoader, enableLoader, staticCanvasImage, fabricatorData, qtActiveCategory, setStaticCanvasImage,
    activePartRelatedItemIndex, activeQuoteIndex, cartItems, visualizerIsChanging} = props;

  useEffect(() => {
    // console.log("qtActiveCategory", qtActiveCategory);
    if (!fabricatorData.settings.useCategorySwitching || !qtActiveCategory || !window.location.href.includes("materials")) {
      return null
    }

    const layout = getCurrentLayout();
    if (!layout.qtCategories) {
      return null
    }
    const currentRoomName = qtActiveCategory.trim().toLowerCase();
    const currentQtCat = layout.qtCategories.find(qtCategory => qtCategory.name === qtActiveCategory);

    const {fabricatorSubscriptions} = fabricatorData;

    if (currentRoomName !== getCommonVisualizerType().toLowerCase()
      && currentQtCat
      && currentQtCat.subParts[activePartRelatedItemIndex]
      && currentQtCat.subParts[activePartRelatedItemIndex].part.partId !== "room"
      && (!fabricatorData.settings.allowVisualizerSwitching || !fabricatorSubscriptions.some(subscription => subscription && subscription.service.toLowerCase() === currentRoomName))) {
      // allowVisualizerSwitching is turned off - show image, or check, if there are no available visualizers with clicked room
      setStaticCanvasImage(getRoomImageFromQtCategory(qtActiveCategory, fabricatorData.settings));
    } else if (staticCanvasImage) {
      setStaticCanvasImage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qtActiveCategory])

  useEffect(() => {
    if (visualizerIsChanging) {
      return
    }
    setStaticCanvasImage(getRoomImageFromQtCategory("", activeQuoteIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeQuoteIndex, cartItems, visualizerIsChanging]) // update when visualizer is switched

  if (!staticCanvasImage) {
    return null
  }

  return (
    <div className="selection-main__image-static">
      <img onLoad={() => disableLoader ? disableLoader() : null}
           onLoadStart={() => enableLoader ? enableLoader() : null}
           alt=""
           src={staticCanvasImage} />
    </div>
  )
};

HardcodedCanvasImage.propTypes = {
  enableLoader: PropTypes.func,
  disableLoader: PropTypes.func,
};

const mapStateToProps = (store) => {
  const {staticCanvasImage} = store.bathroomVisualizerState;
  const fabricatorData = store.fabricatorState;
  const {qtActiveCategory} = store.qtState;
  const {activePartRelatedItemIndex} = store.selectionState;
  const {activeQuoteIndex} = store.quotesState;
  const {cartItems} = store.cartState;
  const {visualizerIsChanging} = store.serverState;

  return {
    staticCanvasImage,
    fabricatorData,
    qtActiveCategory,
    activePartRelatedItemIndex,
    activeQuoteIndex,
    cartItems,
    visualizerIsChanging,
  };
};

const mapDispatchToProps = {
  setStaticCanvasImage
};

export default connect(mapStateToProps, mapDispatchToProps)(HardcodedCanvasImage);
